import axios from 'axios';
import { Message } from 'element-ui';
import { Loading } from "element-ui";
import { getCookie, setCookie, removeCookie, getLoginUUId, getLoginUserId, getLoginRealName, getLoginUserName, getLoginUserUrl } from "../plugins/cookie";
import originJsonp from 'jsonp';



// 拼接url query params
function param(data) { //  data是一个对象一般只有一层
    let url = '';
    for (let key in data) {
        //  为了防止data中值为undefined的情况
        let value = data[key] !== undefined ? data[key] : ''
            //  每一个键值对用&连接
        url += `&${key}=${encodeURIComponent(value)}`
    }
    //  去除url中的第一个&，以免重复
    return url ? url.substring(1) : ''
}
export function jsonp(url, data, option) {

    return new Promise((resolve, reject) => {
        //调用跨域请求函数
        //对URL进行拼接,首页需要判断URL后面是否有“？”，如果有这需要给param(data)添加“&”，不然需要给param(data)添加“？”
        let finalUrl = '//member.zhihuishu.com' + url + (url.indexOf('?') < 0 ? '?' : '&') + param({ unionId: 1000, ...data });
        originJsonp(finalUrl, option, (err, data) => {
            //这里的url就是完整的请求地址，需要包括参数
            if (!err) {
                if (data.currentTime) {
                    window.currentTime = data.currentTime;
                }
                if (data && data.code === '200') {
                    resolve(data.rt) //请求成功
                } else {
                    reject(data.msg);
                }
            } else {
                reject(err) //失败
            }
        })
    })
}


const service = axios.create({
    baseURL: '//member.zhihuishu.com',
    timeout: 30 * 1000
});

// 请求拦截器
let loadingInstance = null;
service.interceptors.request.use(config => {
    loadingInstance = Loading.service({ fullscreen: true });
    config.data = JSON.stringify(config.data);
    config.baseURL = '//member.zhihuishu.com';
    config.headers = {
        'Content-Type': 'application/json',
    }
    const loginUserId = getLoginUserId();
    const loginUUId = getLoginUUId();
    loginUserId && (config.headers.loginUserId = loginUserId);
    loginUUId && (config.headers.loginUUId = loginUUId);
    config.params = { unionId: 1000, ...config.params }
    return config
}, error => {
    Promise.reject(error)
});

// 响应拦截器
service.interceptors.response.use(({ data: { code, msg, rt } = {} }) => {
    loadingInstance.close();
    if (code === 200) {
        return Promise.resolve(rt);
    }
    Message.error(msg || '未知错误！');
    return Promise.reject({ code, msg });
}, error => {
    loadingInstance.close();
    // 异常处理
    if (error && error.response) {
        //公共错误处理
        switch (error.response.status) {
            case 400:
                error.message = '错误请求'
                break;
            case 401:
                error.message = '未授权，请重新登录'
                break;
            case 403:
                error.message = '拒绝访问'
                break;
            case 404:
                error.message = '请求错误,未找到该资源'
                break;
            case 405:
                error.message = '请求方法未允许'
                break;
            case 408:
                error.message = '请求超时'
                break;
            case 500:
                error.message = error.response.message || '服务器端出错'
                break;
            case 501:
                error.message = '网络未实现'
                break;
            case 502:
                error.message = '网络错误'
                break;
            case 503:
                error.message = '服务不可用'
                break;
            case 504:
                error.message = '网络超时'
                break;
            case 505:
                error.message = 'http版本不支持该请求'
                break;
            default:
                error.message = `连接错误${error.response.status}`
        }
    } else {
        // 超时处理
        if (JSON.stringify(error).includes('timeout')) {
            Message.error('服务器响应超时，请刷新当前页')
        }
    }
    // Message.error(error.message)
    return Promise.reject(error.response)
});

export function doGet(url, params) {
    const config = {
        method: 'get',
        url
    }
    if (params) config.params = params
    return service(config);
}

export function doPost(url, params) {
    const config = {
        method: 'post',
        url
    }
    if (params) config.data = params
    return service(config);
}

export function doPut(url, params) {
    const config = {
        method: 'put',
        url
    }
    if (params) config.data = params
    return service(config);
}

export function doDelete(url, params) {
    const config = {
        method: 'delete',
        url
    }
    if (params) config.params = params
    return service(config);
}